import { render, staticRenderFns } from "./BazarProveedor.vue?vue&type=template&id=1a995988&"
import script from "./BazarProveedor.vue?vue&type=script&lang=js&"
export * from "./BazarProveedor.vue?vue&type=script&lang=js&"
import style0 from "./BazarProveedor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports